import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  
  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/browse?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery(''); // Clear search field after submission
    }
  };
  
  return (
    <nav className="navigation">
      <div className="container nav-container">
        <ul className="nav-links">
          <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
            <Link to="/">Home</Link>
          </li>
          <li className={`nav-item ${location.pathname === '/browse' ? 'active' : ''}`}>
            <Link to="/browse">Browse</Link>
          </li>
          <li className={`nav-item ${location.pathname === '/my-list' ? 'active' : ''}`}>
            <Link to="/my-list">My List</Link>
          </li>
          <li className={`nav-item ${location.pathname === '/profile' ? 'active' : ''}`}>
            <Link to="/profile">Profile</Link>
          </li>
        </ul>
        <form className="nav-search" onSubmit={handleSearchSubmit}>
          <input 
            type="text" 
            placeholder="Search" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className="search-btn">
            <span>🔍</span>
          </button>
        </form>
      </div>
    </nav>
  );
};

export default Navigation; 